export default "__VITE_PUBLIC_ASSET__f20511e5__"